module.exports = __webpack_public_path__ + "img/advanced-51.139b7489.png";